'use client';

import React__default from 'react';

var IconArrowLeft = function (props) {
    return (React__default.createElement("svg", { onClick: props.onClick, className: 'iconArrowLeft', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '50px', height: '50px' },
        React__default.createElement("path", { fill: 'none', strokeLinecap: 'round', strokeMiterlimit: '10', strokeWidth: '2', d: 'M19.946 35.891L9.057 25 19.947 14.11M41 25L9.662 25' })));
};

export { IconArrowLeft as default };
//# sourceMappingURL=IconArrowLeft.js.map
